@if (!jornada_concluida() && autoCheckActivo().length == 0) {
    <div fxLayout="row" fxLayoutAlign="space-between center" class="fuse-card card-border-top">
        <div fxLayout="column" fxLayoutAlign="center center" class="p-16" fxLayoutGap="10px">
            @if (
                (estadoActual() === estados.SALIDA || estadoActual() === estados.AUTOCIERRE) && tiempoTrabajado() === 0
            ) {
                <span>{{ "time_control.title" | translate }}</span>
            }
            @if (tiempoTrabajado() > 0) {
                <span class="state-indicator">
                    @if (estadoActual() === estados.TRABAJANDO) {
                        <strong>{{ "time_control.working" | translate }}</strong>
                    }
                    @if (estadoActual() === estados.EN_PAUSA) {
                        <strong>{{ "time_control.in_pause" | translate }}</strong>
                    }
                    @if (estadoActual() === estados.COMIDA) {
                        <strong>{{ "time_control.comiendo" | translate }}</strong>
                    }
                    @if (estadoActual() === estados.SALIDA || estadoActual() === estados.AUTOCIERRE) {
                        <strong>{{ "time_control.checkout" | translate }}</strong>
                    }
                    <br />
                    <!-- <small *ngIf="regEdit">{{ (estadoActual() === estados.SALIDA || estadoActual() === estados.AUTOCIERRE) ? 'a' : 'desde'}} <span class="ion-hide-sm-down">las</span> {{momentHora(regEdit.fecha)}}
          &nbsp;<mat-icon class="editBtn" (click)="openModaEditarRegistro(template)">edit</mat-icon>
        </small> -->
                </span>
            }
            @if (
                (estadoActual() === estados.SALIDA || estadoActual() === estados.AUTOCIERRE) && tiempoTrabajado() === 0
            ) {
                <h1 class="time-text current-date">
                    {{ currentDate | date: "dd-MM-yyyy" }}
                </h1>
            }
            @if (
                estadoActual() === estados.TRABAJANDO ||
                estadoActual() === estados.EN_PAUSA ||
                estadoActual() === estados.COMIDA
            ) {
                <h1 class="time-text">
                    {{ momentTiempoTrabajado() }}
                </h1>
            }
            @if (
                (estadoActual() === estados.SALIDA || estadoActual() === estados.AUTOCIERRE) && tiempoTrabajado() > 0
            ) {
                <h1 class="time-text">
                    {{ momentTiempoTrabajado() }}
                </h1>
            }
        </div>
        @if (estadoActual() === estados.SALIDA || estadoActual() === estados.AUTOCIERRE) {
            <div fxLayout="column" fxLayoutAlign="center center" class="p-16">
                <div style="width: 40px" class="statusIconDiv">
                    <mat-icon style="font-size: 40px; cursor: pointer" (click)="openModalTiposEntradas()"
                        >play_circle_filled</mat-icon
                    >
                </div>
                <span>{{ "time_control.checkin" | translate }}</span>
            </div>
        }
        @if (estadoActual() === estados.TRABAJANDO) {
            <div fxLayout="column" fxLayoutAlign="center center" class="p-16" style="margin-left: 16px">
                <div style="width: 40px" class="statusIconDiv">
                    <!-- Usa el icono que prefieras (ej: "update", "autorenew", "build", etc.) -->
                    <mat-icon style="font-size: 40px; cursor: pointer" (click)="openModalCambioJornada()"
                        >update</mat-icon
                    >
                </div>
                <span>Tipo</span>
            </div>
        }
        @if (estadoActual() === estados.TRABAJANDO) {
            <div fxLayout="column" fxLayoutAlign="center center" class="p-16">
                <div style="width: 40px" class="statusIconDiv">
                    <mat-icon style="font-size: 40px; cursor: pointer" (click)="openModalTiposParada()"
                        >pause_circle_filled</mat-icon
                    >
                </div>
                <span>{{ "time_control.pause" | translate }}</span>
            </div>
        }
        @if (estadoActual() === estados.EN_PAUSA || estadoActual() === estados.COMIDA) {
            <div fxLayout="column" fxLayoutAlign="center center" class="p-16">
                <div style="width: 40px" class="statusIconDiv">
                    <mat-icon style="font-size: 40px; cursor: pointer" (click)="changeStatus('continue')"
                        >play_circle_outline</mat-icon
                    >
                </div>
                <span>{{ "btn.continue" | translate }}</span>
            </div>
        }
        <ng-template #template>
            <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
                <label>{{ "time_control.edit_checkin" | translate }}</label>
                <mat-icon class="pointer" mat-button [mat-dialog-close]="false">close</mat-icon>
            </div>
            <mat-dialog-content>
                <mat-form-field subscriptSizing="dynamic">
                    <input type="time" matInput [(ngModel)]="nuevoHorario" />
                </mat-form-field>
            </mat-dialog-content>
            <div mat-dialog-actions align="end">
                <button mat-button [mat-dialog-close]="false">{{ "general.button.cancel" | translate }}</button>
                <button mat-button [mat-dialog-close]="nuevoHorario">{{ "general.button.accept" | translate }}</button>
            </div>
        </ng-template>
    </div>
}

@if (!jornada_concluida() && autoCheckActivo().length != 0) {
    <div fxLayout="row" class="fuse-card card-border-top">
        <div fxLayout="column" fxFlex="100%" class="p-10" style="max-width: 500px">
            <div fxLayout="row" fxFlex="100%" class="p-8" fxLayoutAlign="center center">
                <span>Parece que no has fichado tu entrada todavía.</span>
            </div>
            <div fxLayout="row" fxFlex="100%">
                @if (!showMotivationForm) {
                    <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" class="p-16" fxLayoutGap="10px">
                        <h5 class="time-text current-date">¿Entraste en tu horario habitual?</h5>
                    </div>
                }
                @if (!showMotivationForm) {
                    <div fxLayout="column" fxFlex="25%" fxLayoutAlign="center center" class="p-10" (click)="showForm()">
                        <div style="width: 40px" class="statusIconDiv">
                            <mat-icon style="font-size: 40px; cursor: pointer">check</mat-icon>
                        </div>
                        <span>Si</span>
                    </div>
                }
                @if (!showMotivationForm) {
                    <div
                        fxLayout="column"
                        fxFlex="25%"
                        fxLayoutAlign="center center"
                        class="p-10"
                        (click)="cancelarCheckAutomatico()"
                    >
                        <div style="width: 40px" class="statusIconDiv">
                            <mat-icon style="font-size: 40px; cursor: pointer">cancel</mat-icon>
                        </div>
                        <span>No</span>
                    </div>
                }
                @if (showMotivationForm) {
                    <div fxLayout="column" fxFlex="50%" fxLayoutAlign="center center" class="p-12">
                        <h5 style="margin: 3px"><b>Por favor, introduzca el motivo</b></h5>
                        <h5 style="margin: 3px; color: rgb(201, 50, 50)">{{ errorValidar }}</h5>
                        <textarea
                            style="width: 90%; margin-bottom: 5px; border-radius: 5px"
                            [(ngModel)]="motivo"
                        ></textarea>
                        <button mat-raised-button color="primary" (click)="validarCheckAutomatico()">Enviar</button>
                    </div>
                }
            </div>
        </div>
    </div>
}
@if (jornada_concluida()) {
    <div fxLayout="row" fxLayoutAlign="space-between center" class="fuse-card card-border-top">
        <div fxLayout="column" fxLayoutAlign="center center" class="p-16" fxLayoutGap="10px">
            <span>No es necesario fichar</span>
            <h2 class="time-text current-date">Fin de jornada</h2>
        </div>
        <div fxLayout="column" fxLayoutAlign="center center" class="p-16">
            <div style="width: 40px" class="statusIconDiv">
                <mat-icon style="font-size: 40px; cursor: pointer">insert_emoticon</mat-icon>
            </div>
            <span>Descansa</span>
        </div>
    </div>
}
